import React from 'react';

// Canonical Button per shared-docs/frontend-architecture.md.
// Variants: primary | secondary | danger. Min-h-[44px] touch target on mobile.
const VARIANTS = {
  primary:
    'bg-primary-600 text-white hover:bg-primary-700 active:bg-primary-800 ' +
    'disabled:opacity-50 disabled:cursor-not-allowed ' +
    'focus:ring-2 focus:ring-primary-500 focus:outline-none',
  secondary:
    'bg-gray-100 text-gray-700 hover:bg-gray-200 active:bg-gray-300 ' +
    'dark:bg-night-surface dark:text-night-text dark:hover:bg-night-card ' +
    'disabled:opacity-50 disabled:cursor-not-allowed ' +
    'focus:ring-2 focus:ring-primary-500 focus:outline-none',
  danger:
    'bg-red-600 text-white hover:bg-red-700 active:bg-red-800 ' +
    'disabled:opacity-50 disabled:cursor-not-allowed ' +
    'focus:ring-2 focus:ring-red-500 focus:outline-none',
};

export default function Button({
  children,
  variant = 'primary',
  className = '',
  type = 'button',
  ...rest
}) {
  return (
    <button
      type={type}
      className={[
        'inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg font-medium min-h-[44px]',
        'transition-colors duration-150',
        VARIANTS[variant] || VARIANTS.primary,
        className,
      ].join(' ')}
      {...rest}
    >
      {children}
    </button>
  );
}
